  import React from 'react';
  import 'index.css'

  import { FaLinkedin } from 'react-icons/fa';
  import Aurora from 'components/ui/Aurora';
  // import BellBackground from 'components/ui/BellBackground';

  const handleMouseMove = e => {
    const { currentTarget: target } = e;
    const rect = target.getBoundingClientRect(),
      x = e.clientX - rect.left,
      y = e.clientY - rect.top;
    target.style.setProperty("--mouse-x", `${x}px`);
    target.style.setProperty("--mouse-y", `${y}px`);
  }

  for(const card of document.getElementsByClassName("card")) {
    card.onmousemove = e => handleMouseMove(e);
  }

  function Background() {
    return (
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-10">
        {/* Aurora background temporarily disabled while BellBackground is used */}
        
          <Aurora
            colorStops={["#FFB232", "#FFB232", "#FFB232"]}
            blend={0.5}
            amplitude={0.3}
            speed={0.7}
          />
        
        {/* <div className="absolute inset-0 -z-10">
          <BellBackground className="w-full h-full" />
        </div> */}
      </div>
    );
  }

  function LinkCard({ href, label, subtitle }) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="card group relative flex h-[28rem] sm:h-[28rem] w-full flex-col justify-end overflow-hidden bg-gradient-to-b from-[#0b0c11]/50 via-[#0f1127]/40 to-[#070709]/50 border border-gray-700/40 p-6 text-left backdrop-blur-md transition hover:shadow-lg hover:from-[#0b0c11]/60"
      >
        <div className="absolute inset-0 pointer-events-none opacity-30 mix-blend-screen" style={{ backgroundImage: `radial-gradient(circle at var(--mouse-x,50%) var(--mouse-y,50%), rgba(255,178,50,0.08), transparent 30%)` }} />
        <div className="relative z-10">
          <div className="text-2xl font-semibold text-white">{label}</div>
          <div class="flex flex-row gap-3 items-center mt-4">
            <div className="left-6 bottom-4 text-sm text-gray-400">↗</div>
            {subtitle && <div className=" text-sm text-gray-300">{subtitle}</div>}
          </div>
        </div>
      </a>
    );
  }

  function LinkCards() {
    const items = [
      { href: 'https://workingfigure.com', label: 'Analytics, visualisations and presentation.', subtitle: 'Blog' },
      { href: 'https://infigure.studio', label: 'An analytics platform built for presenting data', subtitle: 'Infigure' },
      { href: 'https://infigure.studio/components', label: 'Open, production grade visualisation components.', subtitle: 'Infigure Components' },
    ];

    return (
      <div className="w-full">
        <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-3">
          {items.map((it) => (
            <LinkCard key={it.href} href={it.href} label={it.label} subtitle={it.subtitle} />
          ))}
        </div>
      </div>
    );
  }

  function Small() {
    return (
      <div class="flex flex-col flex-grow w-full h-full items-start justify-start md:justify-start min-h-svh cursor-auto selection:bg-[#FFB232] selection:text-black z-20">

        <div class="flex flex-row w-full p-5 justify-center items-center" />

        <div class="flex flex-col w-full h-full flex-grow p-10 justify-start md:justify-center gap-10">
          <div class="card flex flex-row justify-between items-center w-full">
            <div class="flex flex-col leading-3">
              <h1 className="m-0 p-0 text-6xl leading-[3rem] sm:text-8xl sm:leading-[5rem] hover:text-[#FFB232]">Max<br></br>Hornigold</h1>
            </div>
          </div>

          <div class="flex flex-col items-start h-full max-w-[32rem]">
            <div class="flex flex-col gap-4">
              <p class="text-lg sm:text-[1.5rem] sm:leading-[1.9rem] hover:text-[#FFB232]">A data scientist telling stories about sports fans and exploring the future of analytics tooling.</p>
            </div>
          </div>

          <LinkCards />

          <div class="flex flex-col gap-3">
            <a class="card flex h-12 w-12 items-center justify-center bg-transparent p-0 text-[1.0rem] font-[SplineSans-Regular] text-[#FFB232] hover:text-[#FFB232]" href="https://www.linkedin.com/in/max-hornigold-603238206/" aria-label="LinkedIn">
              <FaLinkedin size={24} />
            </a>
          </div>

        </div>
      </div>
    )
  }

  function Page() {  
    if (window.innerWidth < 768) {
      return (
        <div className="h-full relative w-full overflow-hidden flex flex-col items-center justify-center rounded-none">
          <Background />
          <Small />
        </div>
      );
    } 
    return (
      <div className="h-full relative w-full overflow-hidden flex flex-col items-center justify-center rounded-none">
        <Background />
        <div class="flex flex-col flex-grow w-full h-full items-start justify-start md:justify-start min-h-svh cursor-auto selection:bg-[#FFB232] selection:text-black z-20">

          <div class="flex flex-row w-full p-5 justify-between items-center" />

          <div class="flex flex-col w-full h-full flex-grow p-8 sm:p-10 justify-start md:justify-center gap-8">
            <div class="mx-auto w-full max-w-[72rem]">
              <div class="flex flex-row justify-between items-start w-full">
                  
                  <div class="flex flex-col leading-none gap-6">
                    <h1 className="m-0 p-0 text-4xl leading-[2.2rem] sm:text-6xl sm:leading-[3.2rem] hover:text-[#FFB232]">Max<br></br>Hornigold</h1>
                    <p class="text-base sm:text-[1.2rem] max-w-[30rem] sm:leading-[1.6rem] hover:text-[#FFB232]">A data scientist telling stories about sports fans and exploring the future of analytics tooling.</p>
                  </div>

                  <a class="bg-transparent p-0 text-[1.0rem] font-[SplineSans-Regular] hover:text-[#FFB232]" href="https://www.linkedin.com/in/max-hornigold-603238206/" aria-label="LinkedIn">
                    <FaLinkedin size={24} />
                  </a>

              </div>

              <div class="mt-24">
                <LinkCards />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  export default Page;